// extracted by mini-css-extract-plugin
export var errorIcon = "_p3-1";
export var nameLogo = "_p3-0";